// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"303b4fb0","453":"c5698aee"}[chunkId] + ".chunk.js";
};